/*
 * @Author: Cozy
 * @Date: 2024-05-27 13:14:59
 * @LastEditors: Cozy
 * @LastEditTime: 2024-06-27 16:43:42
 * @FilePath: /SChatUI/src/PrivateRoute.js
 * @Description: 
 * 
 * Copyright (c) 2024 by Cozy, All Rights Reserved. 
 */
import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { accessToken, loading, accessibleServices } = useContext(AuthContext);
  const navigate = useNavigate();
  const { service } = useParams(); // 从URL参数中获取当前服务信息

  useEffect(() => {
    // console.debug('[PrivateRoute]: accessToken:', accessToken);
    if (!loading) {
      if (!accessToken) {
        navigate('/login');
      } else if (service && !accessibleServices.includes(service)) {
        console.debug('[PrivateRoute]: accessibleServices:', accessibleServices);
        if (accessibleServices.length > 0) {
          navigate('/' + accessibleServices[0]);
        } else {
          alert('您没有访问权限，请联系管理员');
          navigate('/unauthorized');
        }
      }
    }
  }, [accessToken, loading, navigate, service, accessibleServices]);

  if (loading) {
    return <div>Loading...</div>; // Optionally render a loading indicator
  }

  return children;
};

export default PrivateRoute;

